module.exports = __webpack_public_path__ + "img/esiminar.409af7f.png";